export default "__VITE_ASSET__Bcpp$tMe__"